<template>
    <BasePanel
        headline="lang_GENERIC_CAPTION_CONTRIBUTORS"
        :alvqa="alvqa"
    >
        <template v-slot:panelContent>
            <v-data-table
                :headers="headers"
                :items="listItems"
                hide-default-footer
                :items-per-page="1000"
                :header-props="{ sortIcon: '' }"
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                class="noMinWidth"
            >
            <!-- Headers -->
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                    <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>

            <!-- Items -->
                <template v-slot:[`item.artist`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-artist'">
                        {{ $alvPlugin.getArtistOrPerformerName(item.artist) }}
                    </div>
                </template>
                <template v-slot:[`item.role`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-role'">
                        {{ getRole(item.role) }}
                    </div>
                </template>
                <template v-slot:[`item.primary`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-primary'">
                        {{ getYesOrNo(item.primary) }}
                    </div>
                </template>
            </v-data-table>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'

import { 
    DropdownGeneralArtistRoles,
    DropdownGenericYesNo 
} from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "ReleasesArtistsReadOnlyPanel",
    components: {
        BasePanel
    },
    props: {
        releaseAlvId: {
            type: String
        }
    },
    data() {
        return {
            alvqa: 'label-releases-list-row-' + this.releaseAlvId + '-read-only-panel-artists'
        }
    },
    computed: {
        headers() {
            return [
                {
                    text: this.$t("lang_LABEL_RELEASES_CAPTION_NAME"), 
                    align: "left", 
                    value: "artist",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-artist'
                },
                {
                    text: this.$t("lang_LABEL_RELEASES_ROLE"), 
                    align: "left", 
                    value: "role",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-role'
                },
                {
                    text: this.$t("lang_GENERIC_CAPTION_CHECKBOX_PRIMARY_ARTIST"), 
                    align: "left", 
                    value: "primary",
                    class: 'text-no-wrap',
                    width: "100px",
                    sortable: false,
                    alvqa: this.alvqa + '-header-primary'
                }
            ]
        },

        listItems() { 
            let item = this.$store.getters.getExpandedLabelReleases.find(element => {
                return element.alvId === this.releaseAlvId
            })

            let artists = item.artists === null ? [] : item.artists
            return artists
        }
    },
    methods: {
        getRole(roleValue) {
            let roles = DropdownGeneralArtistRoles

            if(roles !== undefined) {
                let match = roles.find(role => {
                    return role.value === roleValue
                })

                if(match !== undefined) return match.text
                else return ''
            } else {
                return ''
            }
        },
        getYesOrNo(value) {
            if(value == null) value = "no"
            let match = DropdownGenericYesNo.find(element => {
                return element.value === value
            }).text

            return this.$t(match)
        }
    }
}
</script>


<style>
    .noMinWidth table {
        min-width: 0px !important;
        table-layout: fixed;
    }
</style>